import { ApiInstance } from '@src/services/api-instance';
import { getAuthToken } from '@src/services/auth-service';
import type { OrgConfigGetResponseDTO } from './dto/org-config-credentials.get.response.dto';
import type { OrgConfigUpsertBodyDTO } from './dto/org-config-credentials.upsert.body.dto';

export class OrgConfigCredentialsService {
  private readonly client: ApiInstance;

  constructor(client: ApiInstance) {
    this.client = client;
  }

  async get(request: { organizationId: string }): Promise<OrgConfigGetResponseDTO> {
    return (
      await this.client.get<OrgConfigGetResponseDTO>(
        `/aliare-middleware/org-setup/api/v1/${request.organizationId}/config/`,
        {},
        {
          bearerToken: await getAuthToken(),
          settings: {
            maxRetries: 0,
            retryDelay: 0,
            delayType: 'linear',
          },
        },
      )
    ).data;
  }
  async upsert(request: { organizationId: string; body: OrgConfigUpsertBodyDTO }): Promise<OrgConfigGetResponseDTO> {
    return (
      await this.client.put<OrgConfigUpsertBodyDTO, OrgConfigGetResponseDTO>(
        `/aliare-middleware/org-setup/api/v1/${request.organizationId}/config/`,
        {},
        request.body,
        {
          bearerToken: await getAuthToken(),
        },
      )
    ).data;
  }
}
